// extracted by mini-css-extract-plugin
export default {"root":"styles_root__AJWzM","label":"styles_label__kyacJ","textInputContainer":"styles_textInputContainer__TKNOY","input":"styles_input__VeTdn"};